import { render } from "./LeaveCalendar.vue?vue&type=template&id=5363ae42&scoped=true"
import script from "./LeaveCalendar.vue?vue&type=script&lang=js"
export * from "./LeaveCalendar.vue?vue&type=script&lang=js"

import "./LeaveCalendar.vue?vue&type=style&index=0&id=5363ae42&lang=scss&scoped=true"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5363ae42"]])

export default __exports__